import { Api } from '../typings/api';
import { hexToRgba, isSupportingBackdropBlur } from './style';

type Theme = Api.CommonStyles;

interface BaseStyledComponentProps {
	theme: Theme;
}

enum Format {
	SmallSmartphonePortrait = 'only screen and (max-width : 374px)',
	SmartphonePortrait = 'only screen and (max-width : 480px) and (orientation : portrait)',
	SmartphoneLandscape = 'only screen and (min-width : 481px) and (max-width : 896px) and (orientation : landscape)',
	Smartphone = 'only screen and (max-width : 767px)',
	TabletPortrait = 'only screen and (min-width : 768px) and (max-width : 991px) and (orientation : portrait)',
	TabletLandscape = 'only screen and (min-width : 768px) and (max-width : 991px) and (orientation : landscape)',
	Tablet = 'only screen and (min-width : 768px) and (max-width : 991px)',
	SmallDesktop = 'only screen and (min-width : 992px) and (max-width : 1399px)',
	LargeDesktop = 'only screen and (min-width : 1400px)'
}

interface ResolveTemplate extends Api.Template {
	commonStyles: ResolveCommonStyles;
}

interface ResolveCommonStyles extends Api.CommonStyles {
	primary: Api.PrimaryStyle;
}

const notchHeight = '36px';
const navBarHeight = '50px';
const navBarButtonWrapperStyle = `
	cursor: pointer;
	height: 30px;
	width: 30px;
	margin: 1px 12px 0 6px;
	padding: 4px 1px;
	box-sizing: border-box;
`;
const navBarIconStyle = `
	height: 100%;
	width: 100%;
	transition: all 0.2s;
`;

const StyleColor: { [k: string]: string } = {
	Blue100: '#f5faff',
	Blue300: '#2c75ff',
	Blue500: '#0000ff',
	Blue600: '#087dff',
	Blue800: '#001152',
	Red: '#f14d4d',
	LightRed: '#f47171',
	Green: '#40d775',
	White: '#ffffff',
	Black: '#000000',
	Grey50: '#f3f3f3',
	Grey100: '#e8e8e8',
	Grey200: '#d9d9d9',
	Grey300: '#cecece',
	Grey400: '#c3c3c3',
	Grey450: '#999999',
	Grey500: '#8c8c8c',
	Grey600: '#666666',
	Grey650: '#555555',
	Grey700: '#404040',
	Grey800: '#292929',
	Grey900: '#1e1e1e'
};

const NewStyleColor: { [k: string]: string } = {
	White: '#ffffff',
	Grey100: '#f6f6f6',
	Grey200: '#efeff3',
	Grey300: '#eaeaea',
	Grey400: '#a4a4a4',
	Grey500: '#7c7c7c',
	Grey600: '#5f5e5f',
	Grey800: '#4a4a4a',
	Grey900: '#2b2b2b',
	Grey950: '#202020',
	Black: '#000000',
	Yellow: '#ffda00',
	Red100: '#ff001f',
	Red200: '#f5515f',
	Red300: '#d0021b',
	Red400: '#9f041b',
	Orange: '#f7941e',
	IrishGreen: '#009b23',
	VibrantGreen: '#56A100',
	Green: '#81a536',
	Blue50: '#cde5ff',
	Blue100: '#1e69f2',
	Blue200: '#217cf3',
	Blue300: '#00baff',
	Blue400: '#0079ff',
	Pink: '#ff7bac',
};

const defaultTemplate: ResolveTemplate = {
	locale: 'en_US',
	commonStyles: {
		primary: {
			actionColor: StyleColor.Blue600,
			backgroundColor: StyleColor.Grey50,
			cardColor: StyleColor.White,
			contentColor: StyleColor.Grey500,
			spacerColor: StyleColor.Grey300,
			strongColor: StyleColor.Grey800,
			topnavColor: StyleColor.White,
			iconsColor: StyleColor.Black,
			thumbBorderColor: StyleColor.Grey300,
			topnavOpacity: 100
		}
	}
};

const blurredBackgroundColor = isSupportingBackdropBlur() ? hexToRgba(StyleColor.White, 50) : StyleColor.Grey50;

export {
	BaseStyledComponentProps,
	Format,
	ResolveTemplate,
	ResolveCommonStyles,
	StyleColor,
	defaultTemplate,
	NewStyleColor,
	notchHeight,
	navBarHeight,
	navBarButtonWrapperStyle,
	navBarIconStyle,
	blurredBackgroundColor,
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/utils/styles-constants.ts